<div class="row">
    <div class="col-xs-12">
        <div class="subheadertext">Välj område med knapparna för att visa utvecklingen över tid och vilka år som inventerats.</div>
    </div>

    <div class="col-xs-12">
        <app-fordjupning-button-group (selectedOmradeEvent)="onOmradeSelect($event)"></app-fordjupning-button-group>
        <p><b>Valt område</b>: {{ omradeNamn$ | async }}</p>
    </div>
</div>

<div class="row">
    <div class="col-md-8 col-xs-12 col-lg-9">
        <app-rase-forekomst-chart [inventeringar]="inventeringar$ | async" [diagramBeskrivning]="'Historisk utveckling av RASE-stammar per hektar'"></app-rase-forekomst-chart>
    </div>

    <div class="col-md-4 col-xs-12 col-lg-3">
        <ng-container *ngIf="senasteInventering$ | async as senasteInventering">
            <app-summary-card>
                <app-summary-card-icon>
                    <span class="abinicon-tree-chart"></span>
                </app-summary-card-icon>
                <app-summary-card-header>
                    {{ senasteInventering?.antalRASEHa3InvAVG | number : '1.0' : 'sv' }}
                </app-summary-card-header>
                <app-summary-card-content> RASE per hektar. Sammanvägning för de tre senaste inventeringarna </app-summary-card-content>
            </app-summary-card>
        </ng-container>
    </div>
</div>
